import { render, staticRenderFns } from "./PatientGroupPicker.vue?vue&type=template&id=a4c53142&scoped=true"
import script from "./PatientGroupPicker.vue?vue&type=script&lang=js"
export * from "./PatientGroupPicker.vue?vue&type=script&lang=js"
import style0 from "./PatientGroupPicker.vue?vue&type=style&index=0&id=a4c53142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c53142",
  null
  
)

export default component.exports